import React, { useState, useEffect } from 'react';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import RealTimeTrackMap from './RealTimeTrackMap';
import trackingService from '@/services/trackingService';

const RealTimeTrackDialog = ({ isOpen, onClose, trip }) => {
  const [trackingData, setTrackingData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const tripIdRef = React.useRef(trip?.id);

  useEffect(() => {
    if (!isOpen || !trip) return;

    tripIdRef.current = trip.id;

    setTrackingData(null);
    setLoading(true);
    setError(null);

    let active = true;

    const fetchTrackingData = async () => {
      try {
        const data = await trackingService.getTrackingData(tripIdRef.current);
        if (!active) return;
        setTrackingData(data);
      } catch (err) {
        if (!active) return;
        setError('Failed to load tracking data. Please try again later.');
      } finally {
        if (active) {
          setLoading(false);
        }
      }
    };

    fetchTrackingData();

    const interval = setInterval(async () => {
      try {
        const data = await trackingService.getTrackingData(tripIdRef.current);
        if (!active) return;
        setTrackingData(data);
        setError(null);
      } catch (err) {
        if (!active) return;
        setError('Failed to load tracking data. Please try again later.');
      }
    }, 60000);

    return () => {
      active = false;
      clearInterval(interval);
    };
  }, [isOpen, trip?.id]);

  return (
    <Dialog open={isOpen} onOpenChange={(open) => !open && onClose()}>
      <DialogContent className="max-w-4xl max-h-[90vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle>
            Real-time Tracking - {trip?.trip_number || 'Trip'}
          </DialogTitle>
        </DialogHeader>
        <div className="py-4">
          {loading && !trackingData && (
            <div className="flex justify-center items-center h-64">
              <div className="text-center">
                <div className="inline-block animate-spin rounded-full h-8 w-8 border-t-2 border-b-2 border-primary mb-2"></div>
                <p>Loading tracking data...</p>
              </div>
            </div>
          )}
          
          {error && (
            <div className="flex justify-center items-center h-64">
              <div className="text-center text-red-500">
                <p>{error}</p>
                <button 
                  className="mt-2 px-4 py-2 bg-primary text-white rounded-md"
                  onClick={() => window.location.reload()}
                >
                  Retry
                </button>
              </div>
            </div>
          )}
          
          {trackingData && (
            <RealTimeTrackMap trackingData={trackingData} trip={trip} />
          )}
          
          {!loading && !error && !trackingData && !loading && (
            <div className="flex justify-center items-center h-64">
              <p>No tracking data available</p>
            </div>
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default RealTimeTrackDialog;